<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'إدارة الاحداث'" :to="{name: 'events'}">إدارة الاحداث</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'events.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                              <i class="flaticon-computer-4"></i>
                                          بيانات إدارة الاحداث</h4>
                                    </div>
                                </div>
                            </div>
                             <div class="widget-content widget-content-area">
                              <form @submit.prevent="update()">
                                <div class="row mt-4">
                                    <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.event_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['event_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['event_date']">
                                                  {{ getErrors['event_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.name">
                                            <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                                  {{ getErrors['name'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4" v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect
                                                v-model="data.form.lesson_id"
                                                :options="lessons"
                                                :async="false"
                                                :multiple="false"
                                            />
                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>



                                      <div class="col-md-12">
                                       <a href="#" @click.prevent="addStudent" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus">اضافة طالب</a>
                                         <table class="table table-bordered mt-5">
                                          <thead>
                                            <tr>
                                              <th>الطالب</th>
                                              <th colspan="2">الصورة </th>
                                              <th>#</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(s, k) in data.form.students" :key="k">
                                              <td style="width: 50%">
                                                <treeselect :options="students" :auto-load-root-options="true" @input="checkStudentFound($event, k)" v-model="data.form.students[k].student_id" :multiple="false"/>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.item_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="file" ref="file" class="form-control" :id="'exampleFormControlInput' + k" accept="image/*"  @change="uploadImage($event, k)">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.image'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.image']">
                                                    {{ getErrors['students.'+k+'.image'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <img v-if="data.form.students[k].image_path" :src="data.form.students[k].image_path" style="width:100px;heaight:100px" alt="صورة">
                                              </td>

                                              <td>
                                                <a href="#" class="btn btn-danger" @click.prevent="deleteStudent(data.form.students[k])" v-if="k != 0">X</a>

                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>




                                    </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                  <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'events'}">
                                      <span>رجوع</span>
                                    </router-link>

                                   </form>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import VueDatetimeJs from 'vue-datetime-js'
import 'vue-select/dist/vue-select.css';

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      isSync: false,
      teacher: '',
      items: [],
      teachers: [],
      students: [],
      lessons: [],
      lesson: '',
      data: {
        checker: false,
         form:{
            event_date: '',
            lesson_id: '',
            name: '',
            students: [
              {
                student_id: '',
                image: '',
              }
            ]
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    setTimeout(() => {
        this.isSync = true;
      }, 10000);
      this.getRequirements();
  },
  methods: {
    resetForm(){
      this.data.form = {
            event_date: '',
            lesson_id: '',
            students: [
              {
                student_id: '',
                amount: '0',
                attend_status: 'حاضر'
              }
            ]
        };
    },
    uploadImage(e, k){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.students[k].image = e.target.result;
                };
      },
      getInfo(){
        this.$baseApi.get('/events/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
                this.data.form = response.data.data.event;
                this.data.form.students = this.data.form.all_students;
                this.getDataOfSelect();

            }else if(response.data.code == 404){
                router.push('/events');
            }else{
                alert(response.data.data.error);
                router.push('/events');
            }
        });
      },
      checkStudentFound(val, k){
        console.log(val)
      for (let index = 0; index < this.data.form.students.length; index++) {
         if(this.data.form.students[index].student_id == val && k != index){
          this.sweetAlert('الطالب مضاف بالفعل', 'warning');
          setTimeout(() => {
            this.data.form.students[k].student_id = '';

          }, 2000);
          break;
         }
      }
    },

     deleteStudent(data){
      this.data.form.students.splice(this.data.form.students.indexOf(data), 1);
    },
    addStudent(){
      this.data.form.students.push({
          student_id: '',
          image: '',
      })
    },

      update(){
          this.data.isRequested = true;
        this.$baseApi.patch('/events/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
                router.push('/events');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getInfo();
      },
      loadOptions({ action, searchQuery, callback }) {
          this.$baseApi.get('/events/' + this.$route.params.id + '/edit?search_lesson=1' + '&s='+ searchQuery).then((response)=>{
            if(response.data.code == 200){
               callback(null, response.data.data.lessons)

            }
        });
    },
      getLessonCount(val){
        this.students = [];
        this.$baseApi.get('/events/' + this.$route.params.id + '/edit?search_lesson=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.students = response.data.data.students;
            }
        });
      },
      getDataOfSelect(){
        this.$baseApi.get('/events/' + this.$route.params.id + '/edit?pluck=1&lesson=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
               this.students = response.data.data.students;
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
  watch: {
    // Note: only simple paths. Expressions are not supported.
    lesson(newValue) {
      this.data.form.lesson_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
